import CanvasObject from './CanvasObject';
import type SurfaceBase from './SurfaceBase';
import type { Point } from './SurfaceBase';

interface TextProperties {
  color: string;
  backgroundColor: string;
  fontSize: number;
  createdAtZoom: number;
  rotation: number;
}

interface RotateHandleProps {
  point: Point;
  text: string;
  properties: TextProperties;
}

interface TopBboxCoords {
  bboxTopX: number;
  bboxTopY: number;
}

export default class RotateHandle extends CanvasObject {
  point: Point;
  text: string;
  textProperties: TextProperties;
  radius: number = 5;
  lineWidth: number = 2;
  bboxTopX: number;
  bboxTopY: number;
  bboxPadding: number;

  constructor(id: string, surface: SurfaceBase, options: RotateHandleProps) {
    super(id, surface);
    this.point = options.point;
    this.text = options.text;
    this.textProperties = options.properties;
    this.bboxTopX = 0;
    this.bboxTopY = 0;
    this.bboxPadding = 0;

    this.on('hoverStart', () => {
      this.radius = 10;
      this.surface.setCursor('grab');
      this.renderAll();
    });

    this.on('hoverEnd', () => {
      this.radius = 5;
      this.surface.resetCursor();
      this.renderAll();
    });
  }

  setCoords = (point: Point, bbox?: TopBboxCoords) => {
    this.point = point;

    if (bbox) {
      this.bboxTopX = bbox.bboxTopX;
      this.bboxTopY = bbox.bboxTopY;
    }
  };

  render(ctx: CanvasRenderingContext2D) {
    // the bboxPadding is the same value as the font size in EditTextObject.
    // if the bboxPadding/fontSize is less than 5, skip rendering.
    if (this.bboxPadding < 5) {
      return;
    }

    const store = this.getStore();
    if (typeof store.currentObject === 'undefined') return;

    // rotate handle offset is the length of the line connecting the handle and bbox.
    // used a separate variable just to be more clear.
    const rotateHandleOffset = this.bboxPadding;

    // draw handle
    ctx.lineWidth = this.lineWidth;
    //@ts-expect-error
    ctx.strokeStyle = store.currentObject.properties.color;
    ctx.moveTo(this.bboxTopX, this.bboxTopY);
    ctx.lineTo(this.bboxTopX, this.bboxTopY - rotateHandleOffset);
    ctx.stroke();

    // draw rotation point
    //@ts-expect-error
    ctx.fillStyle = store.currentObject.properties.color;
    ctx.beginPath();
    ctx.arc(this.bboxTopX, this.bboxTopY - rotateHandleOffset, this.radius, 0, 2 * Math.PI);
    ctx.fill();
  }

  drawHitArea(ctx: OffscreenCanvasRenderingContext2D, color: string) {
    if (this.bboxPadding < 5) {
      return;
    }

    const rotateHandleOffset = this.bboxPadding;

    ctx.strokeStyle = color;
    ctx.fillStyle = color;
    ctx.lineWidth = this.lineWidth;

    // draw rotation point
    ctx.beginPath();
    ctx.arc(this.bboxTopX, this.bboxTopY - rotateHandleOffset, this.radius * 2, 0, 2 * Math.PI);
    ctx.closePath();
    ctx.fill();
  }
}
